const CHATKIT_SCRIPT_ID = 'openai-chatkit-script';
const CHATKIT_SCRIPT_URL = 'https://cdn.platform.openai.com/deployments/chatkit/chatkit.js';

export const loadChatkitScript = () => {
  if (document.getElementById(CHATKIT_SCRIPT_ID)) return Promise.resolve();

  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = CHATKIT_SCRIPT_URL;
    script.async = true;
    script.id = CHATKIT_SCRIPT_ID;
    script.onload = resolve;
    document.head.appendChild(script);
  });
};
